// backend
//const hostname = "http://localhost:3500"
const hostname = "https://smartcandidate-extension.onrender.com"

export default hostname;